import { render } from "./EditQuoteModal.vue?vue&type=template&id=50023470"
import script from "./EditQuoteModal.vue?vue&type=script&lang=js"
export * from "./EditQuoteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__